import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ReactiveFormsModule, FormControl, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { NgToastService } from 'ng-angular-popup';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IttSectionDialogsComponent } from '../itt-section-dialogs.component';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RichTextEditorComponent } from '@/app/components/shared/rich-textEditor/rich-textEditor.component';
import { ApiErrorResponse } from '@/app/interfaces/apiErrorResponse.interface';
import { MessagesEnum } from '@/app/enums/message.enum';
import { tendererServiceAdding } from '@/app/interfaces/tendererDialogs.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { RfpLabelService } from '@/app/components/projects/project-development/tendering/inivitation-to-tender/rfp-labels.service';

@Component({
  standalone: true,
  providers: [provideNativeDateAdapter()],
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDatepickerModule,
    RichTextEditorComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-consultancy-services',
  templateUrl: './consultancy-services.component.html',
  styleUrls: ['./consultancy-services.component.css'],
})
export class ConsultancyServicesComponent implements OnInit {
  isRFPorRFQ: string;
  labels: any;
  constructor(
    private IttSectionDialogsComponent: IttSectionDialogsComponent,
    private toast: NgToastService,
    private TenderingService: TenderingService,
    private route: ActivatedRoute,
    private rfpLabelService: RfpLabelService,
    private router: Router
  ) {}

  @Output() closeModalEvent = new EventEmitter<boolean>();
  @Output() consultancyServiceDataEmitter: EventEmitter<any> = new EventEmitter<any>();
  
  @Input() tendererResponseData: any;

  resetRichTextEditor = false;
  isEdit = false;
  eoiTitle: FormControl<any>;
  submittedGuidlines: any;
  form: FormGroup = new FormGroup({
    project_management_control: new FormControl('', Validators.required),
    design_service_control: new FormControl('', Validators.required),
    cost_consultancy_control: new FormControl('', Validators.required),
    contract_administration_control: new FormControl('', Validators.required),
    risk_management_control: new FormControl('', Validators.required),
    sustainability_compliance_control: new FormControl('',Validators.required),
    final_inspection_control: new FormControl('', Validators.required),
  });

  closeModal = true;

  ngOnInit(): void {
    // Subscribe to route changes
    this.route.url.subscribe(() => {
      const currentRoute = this.router.url; // Get full URL path
      this.rfpLabelService.updateLabelsFromRoute(currentRoute);
      this.isRFPorRFQ = this.rfpLabelService.updateRFPorRFQFlag(currentRoute);
    });
    this.rfpLabelService.labels$.subscribe((labels) => {
      this.labels = labels;
    });
    this.TenderingService.isEdit$.subscribe((state) => {
      this.isEdit = state;
    });

    if (this.tendererResponseData) {
      this.mapRFPExistingData();
    }

  }

  setProjectManagement(content: string) {
    this.form.controls['project_management_control'].setValue(content);
  }
  setDesignService(content: string) {
    this.form.controls['design_service_control'].setValue(content);
  }
  setCostConsultancy(content: string) {
    this.form.controls['cost_consultancy_control'].setValue(content);
  }
  setContractAdministration(content: string) {
    this.form.controls['contract_administration_control'].setValue(content);
  }
  setRiskManagement(content: string) {
    this.form.controls['risk_management_control'].setValue(content);
  }
  setSustainabilityCompliance(content: string) {
    this.form.controls['sustainability_compliance_control'].setValue(content);
  }
  setFinalInspection(content: string) {
    this.form.controls['final_inspection_control'].setValue(content);
  }

  prepareDataToSubmit() {
    if (this.form.valid) {
      const data = {
        project_management: this.form.value.project_management_control,
        design_services: this.form.value.design_service_control,
        cost_consultancy: this.form.value.cost_consultancy_control,
        contract_administration: this.form.value.contract_administration_control,
        risk_management: this.form.value.risk_management_control,
        sustainability_compliance: this.form.value.sustainability_compliance_control,
        final_sustainability_compliance: this.form.value.final_inspection_control,
      };
      return data;
    }
  }

  moveToNextStep() {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      this.toast.warning(MessagesEnum.REQUIRED_ALL_FIELDS, 'WARNING', 4000);
      return;
    }

    const dataToSubmit = this.prepareDataToSubmit();
    
    this.TenderingService.addITTConsultancyService(dataToSubmit).subscribe({
      next: (data: tendererServiceAdding) => {
        if (data?.meta?.success) {
          this.toast.success(data?.meta?.message, 'SUCCESS');
          this.IttSectionDialogsComponent.nextStep();
        }
      },
      error: (error: ApiErrorResponse) => {
        console.error('Failed to submit:', error);
        this.toast.danger(error.error.message, 'DANGER', 4000);
      },
    });
  }

  mapRFPExistingData() {
    if (!this.tendererResponseData) {
      console.warn('Tenderer Response Data is undefined');
      return;
    }
  
    this.form.patchValue({
      project_management_control: this.tendererResponseData?.projectManagement ?? '',
      design_service_control: this.tendererResponseData?.designServices ?? '',
      cost_consultancy_control: this.tendererResponseData?.costConsultancy ?? '',
      contract_administration_control: this.tendererResponseData?.contractAdministration ?? '',
      risk_management_control: this.tendererResponseData?.riskManagement ?? '',
      sustainability_compliance_control: this.tendererResponseData?.sustainabilityCompliance ?? '',
      final_inspection_control: this.tendererResponseData?.finalSustainabilityCompliance ?? '',
    });
  }
  
}
